'use strict';

import settings from '../settings';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { HttpContext } from '../utils/httpContext';

class HirService {
  async GetKategoriak() {
    const url = settings.baseUrl + 'Api/Hir/GetKategoriakDarabszammal';
    const result = await HttpContext.post({ url });
    store.dispatch(AppStoreTypes.hirKategoriak.set, {
      value: result,
    });
    return result;
  }
  async GetAktivSzerzok(nap = 30) {
    const url = settings.baseUrl + 'Api/Hir/GetAktivSzerzok';
    let data = { nap };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirek({
    kategoriaId,
    alkategoriaId,
    szerzoId,
    utolsoHirId,
    mennyiseg,
    superAdminFl,
  }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirek';
    let data = {
      kategoriaId,
      alkategoriaId,
      szerzoId,
      utolsoHirId,
      mennyiseg: mennyiseg ?? settings.perPage,
      superAdminFl,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirekSzerzokhoz({
    kategoriaId,
    alkategoriaId,
    szerzoId,
    utolsoHirId,
    mennyiseg,
    superAdminFl,
  }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirekSzerzokhoz';
    let data = {
      kategoriaId,
      alkategoriaId,
      szerzoId,
      utolsoHirId,
      mennyiseg: mennyiseg ?? settings.perPage,
      superAdminFl,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirekLapozhato({
    kategoriaId,
    alkategoriaId,
    szerzoId,
    mennyiseg,
    oldal,
  }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirekLapozhato';
    let data = {
      kategoriaId,
      alkategoriaId,
      szerzoId,
      oldal,
      mennyiseg: mennyiseg ?? settings.perPagePaginated,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetNepszeruHirek({
    kategoriaId,
    alkategoriaId,
    utolsoNepszerusegiIndexId,
  }) {
    const url = settings.baseUrl + 'Api/Hir/GetNepszeruHirek';
    let data = {
      kategoriaId,
      alkategoriaId,
      utolsoNepszerusegiIndexId,
      mennyiseg: settings.perPage,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetNepszeruHirekLapozhato({ kategoriaId, alkategoriaId }) {
    const url = settings.baseUrl + 'Api/Hir/GetNepszeruHirekLapozhato';
    let data = {
      kategoriaId,
      alkategoriaId,
      mennyiseg: 3,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHir({ hirId }) {
    const url = settings.baseUrl + 'Api/Hir/GetHir';
    let data = { hirId };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirByAzonosito({ azonosito }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirByAzonosito';
    let data = { azonosito };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetVezerHir() {
    const url = settings.baseUrl + 'Api/Hir/GetVezerHir';
    const result = await HttpContext.post({ url });
    return result;
  }
  async GetAltalamOlvasottHirek({ utolsoHirId }) {
    const url = settings.baseUrl + 'Api/Hir/GetAltalamOlvasottHirek';
    let data = { utolsoHirId, mennyiseg: settings.perPage };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetFontosHirek({ kategoriaId, alkategoriaId, utolsoHirId }) {
    const url = settings.baseUrl + 'Api/Hir/GetFontosHirek';
    let data = {
      kategoriaId,
      alkategoriaId,
      utolsoHirId,
      mennyiseg: settings.perPage,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async SetKedvencHir({ hirId, kedvencFl }) {
    const url = settings.baseUrl + 'Api/Hir/SetKedvencHir';
    let data = { hirId, kedvencFl };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetYoutubeVideok() {
    const url = settings.baseUrl + 'Api/Hir/GetYoutubeVideok';
    const result = await HttpContext.post({ url });
    return result;
    // let res = [];
    // for (let i = 0; i < 15; i++) {
    //   res.push({
    //     Id: '5267H34FsNU',
    //     Title: 'AZ IGAZSÁG VÉDELMÉBEN',
    //     Published: '2021-04-19T07:45:50+00:00',
    //   });
    //   res.push({
    //     Id: 'YjtUU9HFBcY',
    //     Title: 'Kutya',
    //     Published: '2021-04-19T07:45:50+00:00',
    //   });
    //   res.push({
    //     Id: 'P6IGVLVZo',
    //     Title: 'Kutya',
    //     Published: '2021-04-19T07:45:50+00:00',
    //   });
    // }
    // return res;
  }
  async GetKiemeltKategoria() {
    const url = settings.baseUrl + 'Api/Hir/GetKiemeltKategoria';
    const result = await HttpContext.post({ url });
    return result;
  }
  async GetMegosztottCikk(azon) {
    let data = { link: azon };
    const url = settings.baseUrl + 'Api/Hir/GetMegosztottCikk';
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirekByKeresoszoveg({ keresoszoveg, utolsoHir }) {
    const data = { keresoszoveg, utolsoHir };
    const url = settings.baseUrl + 'Api/Hir/GetHirekByKeresoszoveg';
    const result = await HttpContext.post({ url, data });
    return result;
  }
}

let instance = new HirService();
export { instance as hirService };
global.BvHirek.services.hirService = instance;
